import { IListningarCategory } from './types';

// Listningar starts empty until categories are created in the UI.
export const LISTNINGAR_CATEGORIES: IListningarCategory[] = [];

export function getCategoryByIdFromList(categories: IListningarCategory[], id: string): IListningarCategory | undefined {
  return categories.find(c => c.id === id);
}

export function getCategoryById(id: string): IListningarCategory | undefined {
  return LISTNINGAR_CATEGORIES.find(c => c.id === id);
}

export function getCategoryColor(id: string): string {
  return getCategoryById(id)?.color || '#607D8B';
}

export function getCategoryLabel(id: string): string {
  return getCategoryById(id)?.label || id;
}

// Reaction emoji mapping — single heart like Instagram
export const REACTION_EMOJIS: Record<string, string> = {
  heart: '❤️',
};

export const REACTION_TYPES = Object.keys(REACTION_EMOJIS);
